export default __webpack_public_path__ + "static/media/CallToActionPartner.86095805.png";